import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'p-toast-inpage',
  templateUrl: './p-toast-inpage.component.html',
  styleUrls: ['./p-toast-inpage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PToastInpageComponent {
  @Input() title!: string;
  @Input() closable = true;

  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}
